"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPictureFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M4 4v24h24V4zm21 17a1.88 1.88 0 01-2-2v-1h-1a10 10 0 00-5.62 2.21 2.47 2.47 0 01-2.15.74c-3-.7-2.25-6.75-2.24-6.81l.16-1.14H11a11.31 11.31 0 00-5 1.31V6h20v15z" }),
        React.createElement("path", { d: "M19.5 9a3.5 3.5 0 103.5 3.5A3.5 3.5 0 0019.5 9zm0 5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z" })));
}
exports.default = SvgPictureFilled;
//# sourceMappingURL=PictureFilled.js.map